// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"1207e782","706":"2afdb109","768":"e14350bf","885":"dc6e659d"}[chunkId] + ".css";
};